import { render, staticRenderFns } from "./PrintDeliveryReceipt.vue?vue&type=template&id=f36f8fc0&"
import script from "./PrintDeliveryReceipt.vue?vue&type=script&lang=js&"
export * from "./PrintDeliveryReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports